import { Component, ElementRef, EventEmitter, Output, ViewChild } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { HotelService } from 'src/app/services/hotel.service';
import * as HotelLef from 'leaflet';
import {map, startWith} from 'rxjs/operators';
import { Router ,ActivatedRoute} from '@angular/router';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators,FormControl, FormsModule, ReactiveFormsModule, FormArray } from '@angular/forms'
import { DatePipe } from '@angular/common';
import { ToastMsg, ToastmsgService } from 'src/app/util/toastmsg/toastmsg.service';
import {SettingsService} from '../../services/settings.service';
import { DialogService } from 'src/app/util/dialog/dialog.service';
import { UserInfo, UserInfoService } from 'src/app/services/user-info.service';
import {TripService} from 'src/app/services/trip.service'
import { UserService } from 'src/app/services/user.service';

declare let google: any;

interface Amenity {
  name: string;
  displayName: string;
}

@Component({
  selector: 'app-hotel-details',
  templateUrl: './hotel-details.component.html',
  styleUrls: ['./hotel-details.component.css']
})
export class HotelDetailsComponent  {
  departure:any
  adult:any;
  child:any;
  room:any;
  london:any=new Date()
  markers: L.Marker[] = [];
  showPending:boolean=false
  propData:any
searchDetail:any
pointer:any
starRating:any
map:any
hotelName:any
searchFg!:FormGroup
currentNumber: number = 1;
  ccurrentNumber: number = 0;
  icurrentNumber: number = 1;
@ViewChild('rooms') roomsElement!: ElementRef;
@ViewChild('location') locationElement!: ElementRef;
id:any
amenities: Amenity[] =[]
groupedAmenities: { [key: string]: Amenity[] } = {};
osm:any
departureTime:any
arrivelTime:any
messageRequestid:any
userType:any
userUuid:any
loginUserType:any=''
  constructor(private UserService:UserService,private TripService:TripService,private userInfoService:UserInfoService,private toastMsgService : ToastmsgService,private fb : FormBuilder,private route:ActivatedRoute,private DataService:DataService,private HotelService:HotelService, private  SettingsService:SettingsService,private DialogService:DialogService){
    this.ENABLE_TRIP_MGMT()
    // this.showPending=true
    this.userType=this.userInfoService.getUserType()
    this.userType=this.userType.toUpperCase()
    this.userUuid=this.userInfoService.getUserUuid()

    this.loginUserType=sessionStorage.getItem('loginUserType')
    this.loginUserType=this.loginUserType.toUpperCase()


    this.getActiveTripList()
  //   this.osm = HotelLef.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  //   maxZoom: 19,
  //   attribution: '© OpenStreetMap contributors'
  // });
  // this.route.queryParams.subscribe((messageDetail:any) => {
    this.route.paramMap.subscribe(params => {
      let messageDetail:any= params.get('token');
     
  let messageData:any
  let message:any
  messageData=JSON.parse(this.SettingsService.decodeTransformed(messageDetail))
message=messageData
this.departure=message?.searchDetail?.city
// console.log(message)
// console.log(message?.searchDetail.childrenAges)
  this.searchFg=this.fb.group({
    "from" :  [message?.searchDetail?.city,[Validators.required]],
    "to" : ["",[Validators.required]],
    "requestedDate":[this.convertZone(message?.searchDetail?.checkInDate)],
    "requestedClass":[""],
    "paxCount":[0],
    "adultCount":[0],
    "childCount":[0],
    "infantCount":[0],
    "returnDate":[this.convertZone(message?.searchDetail?.checkOutDate)],
    "menu":['return'],
    // "childrenAges": this.fb.array(message?.searchDetail?.childrenAges)

  });
// this.currentNumber=message?.searchDetail?.adultCount
// this.ccurrentNumber=message?.searchDetail?.childCount
//   this.icurrentNumber=message?.searchDetail?.roomCount

  this.roomss=message?.searchDetail?.rooms
  this.roomCount=message?.searchDetail?.roomCount

  // console.log(message)
this.hotelName=message?.name
  if(this.searchFg?.value?.requestedDate){
    this.departureTime=this.dateFormate(this.searchFg?.value?.requestedDate)?.split(' ')
  }
  if(this.searchFg?.value?.returnDate){
    this.arrivelTime=this.dateFormate(this.searchFg?.value?.returnDate)?.split(' ')
  }

  // this.adult=this.currentNumber+` `+"Adult"

  // this.child=this.ccurrentNumber+` `+"Child"
  this.adult=this.calculateTotals(this.roomss).totalAdults+` `+"Adult"
  this.child=this.calculateTotals(this.roomss).totalChildren+` `+"Child"
  if(this.roomCount>1){
    this.room=this.roomCount+` `+"Rooms"

  }else{
    this.room=this.roomCount+` `+"Room"

  }

    // this.DataService.portMessage.subscribe((message:any) => {
      this.starRating=message?.items?.starRating
      this.id=message?.items?.id
 
      this.pointer=message?.scrollData
      // this.hotelDetail(message?.items)
      //  this.getHotel(this.id)
      this.messageRequestid=message?.items?.id
      this.hotelDetailByDetail(message?.searchDetail,message?.items?.id)

      // this.propData = message?.items
      this.searchDetail=message?.searchDetail

    //  this.pointer=message?.scrollData
      
    


//      if(this.propData) {
//      this.amenities=this.propData?.amenities

//      this.groupAmenities()

//      this.propData.slideIndex=1



     
// this.showSlides(this.propData.slideIndex,this.propData)
// this.initializeMap(this.propData.location)




//      this.propData.rooms.forEach((item:any)=>{
//        item.slideIndex = 1;

       
//        item.slides = this.fetchImageByCode(item.code)
//        this.showRoomSlides( item.slideIndex, item);

//      })
    
//  setTimeout(() => {
//  if(message.scrollData==='all'){

//  }else if(message?.scrollData==='rooms'){
//    let rooms:any 
//    this.scroll(this.roomsElement.nativeElement);

//  }else if(message.scrollData==='location'){
//    this.scroll(this.locationElement.nativeElement);

//  }
// }, 100);
    
    
//      } 






    
    })

    // this.showSlides( this.propData.slideIndex, this.propData);
  }

    ngAfterViewInit() {
      
      // Now that the view is initialized, roomsElement is available.
    }
plusSlides(n: number,item:any): void {
this.showSlides(item.slideIndex += n,item);
  
}

currentSlide(n: number,item:any): void {
  this.showSlides(item.slideIndex = n,item);
}

private showSlides(n: number,item:any): void {
  if (n > item.mmtMedia.length) { item.slideIndex = 1 }
  if (n < 1) { item.slideIndex = item.mmtMedia.length }
  // Normally, Angular handles showing and hiding via structural directives, so you might not need this part.
}


roomSlides(n: number,item:any){
  this.showRoomSlides(item.slideIndex += n,item);


}
private showRoomSlides(n: number,item:any): void {
  if (n > item.slides.length) { item.slideIndex = 1 }
  if (n < 1) { item.slideIndex = item.slides.length }
  // Normally, Angular handles showing and hiding via structural directives, so you might not need this part.
}
scroll(el: HTMLElement) {
  
  el.scrollIntoView({ behavior: 'smooth' });

}
popup:boolean=false
popupData:any
moreDetails(item:any){
  this.popupData=item
  this.popup=true

}
closePopup(){
this.popup=false
}
openCity(evt: any, cityName: string): void {
  let tabcontent: HTMLCollectionOf<Element> = document.getElementsByClassName("tabcontent");
  for (let i = 0; i < tabcontent.length; i++) {
    (tabcontent[i] as HTMLElement).style.display = "none";
  }

  let tablinks: HTMLCollectionOf<Element> = document.getElementsByClassName("tablinks");
  for (let i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace("active", "");
  }

  let cityElement: HTMLElement | null = document.getElementById(cityName);
  if (cityElement) {
    cityElement.style.display = "block";
    evt.currentTarget.className += " active";
  }
}
@Output() myOutput:EventEmitter<string>= new EventEmitter();  

outputMessage:string="close"
backClick(){
  window.close();

  // this.DataService.deliverMsg(this.searchDetail)
  // this.myOutput.emit(this.outputMessage);
  // this.ngOnDestroy()
}



hotelDetail(res:any){
  if(res) {
    if(res) {

    let data:any
    data=res
    console.log(data)

   this.propData=data

   this.propData.rooms=this.propData.rooms.filter((item:any)=>item.soldOut!=true)
   this.amenities=this.propData?.mmtAmenities

   this.groupAmenities()

   this.propData.slideIndex=1

   

    this.propData.media.hotel[0].images.forEach((items:any)=>{
      // let itm={url:items.url.replace('//', 'https://')}
      items.url=items.url.replace('//', 'https://')
     })
    

   
this.showSlides(this.propData.slideIndex,this.propData)

this.initializeMap(this.propData.location)




   this.propData.rooms.forEach((item:any)=>{
     item.slideIndex = 1;

     
     item.slides = this.fetchImageByCode(item.code)

     let slidImg:any=[]
     item.slides.forEach((items:any)=>{
     let itm={url:items.url.replace('//', 'https://')}
     // console.log(itm)
     slidImg.push(itm)
    })
    item.slides=slidImg

     this.showRoomSlides( item.slideIndex, item);

   })
console.log(data)
  
setTimeout(() => {
if(this.pointer==='all'){

}else if(this.pointer==='rooms'){
 let rooms:any 
 this.scroll(this.roomsElement.nativeElement);

}else if(this.pointer==='location'){
 this.scroll(this.locationElement.nativeElement);

}
// this.getChargerById({uuid:this.messageData.uuid});
}, 100);
  
  
  } }
}
requestIds:any={
  mmtRequestId:'',
  agodaSearchId:''    
  }

hotelDetailByDetail(item:any,id:any){
  this.showPending=true

  // this.osm = HotelLef.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
  //   attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>'
  // });
  let maps:any
  this.map=maps
  
  

  this.propData=null
let  request:any={
    "city": item?.city,
    "checkInDate": item?.checkInDate,
    "checkOutDate": item?.checkOutDate,
    "roomCount": item?.roomCount,
    // "adultCount": item?.adultCount,
    // "childCount": item?.childCount,
    
    "hotelId":id,
    "rooms":item?.rooms,
    "country":item?.country,
    'requestId': item?.requestId,
    'rateType':item.rateType

    // "childrenAges":item?.childrenAges
    
  }

  this.HotelService.hotelDetailByDetail(request)
  .subscribe({
    next : (res:any) => {
      this.showPending=false
      if(res) {
         
        if(res.hotel) {
          if (Object.keys(res.hotel).length != 0) {
        let data:any
        data=res?.hotel
        this.requestIds={
          mmtRequestId:res?.mmtRequestId,
          agodaSearchId:res?.agodaSearchId,
          expediaSessionId:res?.expediaSessionId,
          }
       this.propData=this.convertToSameFormate(data)
       
      //  this.propData.mmtRooms=this.propData.mmtRooms.filter((item:any)=>item.soldOut!=true)
       this.amenities=this.propData?.mmtAmenities
 
       this.groupAmenities()
       setTimeout(() => {
        this.initMap();
      }, 0);      
       this.propData.slideIndex=1
        // this.propData.mmtMedia.forEach((items:any)=>{
        //   // let itm={url:items.url.replace('//', 'https://')}
        //   items=items.replace('//', 'https://')
        //  })
        this.propData.mmtMedia = this.propData.mmtMedia.map((items: any) => {
  // items.replace('//', 'https://')
                    if (items && !(items.startsWith("https://") || items.startsWith("http://"))) {
                   return    items.replace('//', 'https://');
                   
                    }
                      return items
                    
                  }
);
        //  console.log(this.propData.mmtMedia)

        
 
       
 this.showSlides(this.propData.slideIndex,this.propData)
 
//  this.initializeMap(this.propData.location)
 
 

 
       this.propData.mmtRooms?.forEach((item:any)=>{
         item.slideIndex = 1;
 
         
        // item.slides = this.fetchImageByCode(item.code)
        item.slides=item?.media
         let slidImg:any=[]
         item.slides.forEach((items:any)=>{
         let itm={url:items.replace('//', 'https://')}
         // console.log(itm)
         slidImg.push(itm)
        })
        item.slides=slidImg

         this.showRoomSlides( item.slideIndex, item);
 
       })
       this.propData.expediaRooms?.forEach((item:any)=>{
        item.slideIndex = 1;

        
       // item.slides = this.fetchImageByCode(item.code)
        let slidImg:any=[]
        function processImages(images:any) {
          if(images){
          const sortedImages = images
              .sort((a:any, b:any) => b.hero_image - a.hero_image) // Sort by hero_image (true comes first)
              .flatMap((image:any) => image.links.map((link:any) => link.href)); // Extract href values from links
      
          return sortedImages;
          }
      }
      item.slides=processImages(item?.metadata?.images)||[]

        item.slides.forEach((items:any)=>{
          
        // console.log(items)
        let itm:any={url:items}
        if (itm && !(itm.url.startsWith("https://") || itm.url.startsWith("http://"))) {
                   itm.url= itm.replace('//', 'https://');
                   
                    }
        // console.log(itm)
        slidImg.push(itm)
       })
       item.slides=slidImg

        this.showRoomSlides( item.slideIndex, item);

      })
      
 setTimeout(() => {
   if(this.pointer==='all'){
 
   }else if(this.pointer==='rooms'){
     let rooms:any 
     this.scroll(this.roomsElement.nativeElement);
 
   }else if(this.pointer==='location'){
     this.scroll(this.locationElement.nativeElement);
 
   }
 // this.getChargerById({uuid:this.messageData.uuid});
 }, 100);
      


 
      
      }} } else {    
       } 
    
    }
    ,error : (err) => {
      this.showPending=false

      console.log(err)
            
          }
    
    }
      
      )



}
@ViewChild('mapChr', { static: false }) mapElement!: ElementRef;

 initMap() {
  console.log(this.mapElement)
  
    if (this.mapElement) {
      const mapDiv = this.mapElement.nativeElement;
      console.log(mapDiv)
      this.map = new google.maps.Map(mapDiv, {
        center: { lat: this.propData?.latitude, lng: this.propData?.longitude },
        zoom: 15
      });

      const marker = new google.maps.Marker({
        position: { lat: this.propData.latitude, lng: this.propData.longitude },
        map: this.map
      });

      const popupContent = `
        <span style="color:blue"><b>${this.propData.name}</b></span><br>
       
      `;
      // <b>${this.propData.location.baseCityName} | ${this.propData.location.state} | ${this.propData.location.countryName}</b>

      const infoWindow = new google.maps.InfoWindow({
        content: popupContent
      });

      marker.addListener('mouseover', () => {
        infoWindow.open(this.map, marker);
      });

      marker.addListener('mouseout', () => {
        infoWindow.close();
      });
    }
  }
getHotel(id:any){
   
  this.HotelService.hotelDetailById(id)
  .subscribe({
    next : (res:any) => {
      
      if(res) {
       let data:any
       data=res  
      this.propData=data[0]
      this.amenities=this.propData?.amenities

      this.groupAmenities()

      this.propData.slideIndex=1



      
this.showSlides(this.propData.slideIndex,this.propData)

this.initializeMap(this.propData.location)




      this.propData.rooms.forEach((item:any)=>{
        item.slideIndex = 1;

        
        // item.slides = this.fetchImageByCode(item.code)

        let slidImg:any=[]
        item.slides.forEach((items:any)=>{
        let itm={url:items.url.replace('//', 'https://')}
        // console.log(itm)
        slidImg.push(itm)
       })
       item.slides=slidImg
        
        this.showRoomSlides( item.slideIndex, item);

      })
console.log(data)
     
setTimeout(() => {
  if(this.pointer==='all'){

  }else if(this.pointer==='rooms'){
    let rooms:any 
    this.scroll(this.roomsElement.nativeElement);

  }else if(this.pointer==='location'){
    this.scroll(this.locationElement.nativeElement);

  }
// this.getChargerById({uuid:this.messageData.uuid});
}, 100);
     
     
      } else {    
      } 
    },error : (err) => {
console.log(err)
      
    }
  }
)
}


groupAmenities(): void {
  this.amenities.forEach(amenity => {
    if (!this.groupedAmenities[amenity.name]) {
      this.groupedAmenities[amenity.name] = [];
    }
    this.groupedAmenities[amenity.name].push(amenity);
  });
}
objectKeys(obj: any): string[] {
  return Object.keys(obj);
}

fetchImageByCode(code:any){
  let returnData:any=[]
  returnData=this.propData.media.room[0].images.filter((item:any)=>item.roomCode===code)
  return returnData
}


ngOnDestroy() {
  if (this.map) {
    this.map.remove();
  }
}
initializeMap(item:any){
console.log(item)
 



  if (this.map) {

    // if (!this.map._initHooksCalled) {
    // this.map.remove();
    // this.map = null;
    // console.log(this.map)

  }
 
//   setTimeout(() => {
//   this.map = HotelLef.map('mapChr', {
//     center: [28.5943549, 77.3321085],
//     zoom: 10,
//     layers: [this.osm],
//     attributionControl:false
//   })

// }, 100);
}

initMarkers(item:any) {
   
  const initialMarkers = [
    {
      position: { lat: item?.geo?.lat, lng: item?.geo?.long},
      draggable: false
    },
   
  ];
  console.log()
  for (let index = 0; index < initialMarkers.length; index++) {
    const data = initialMarkers[index];
    const marker = this.generateMarker(item,data, index);
    marker.addTo(this.map).bindPopup(`<b>${item.baseCityName} | ${item?.state} | ${item.countryName}</b>`);
    this.map.panTo(data?.position);
    this.markers.push(marker)
  }
}

generateMarker(item:any,data: any, index: number) {
  if(item){
    HotelLef.Icon.Default.mergeOptions({
          iconRetinaUrl: 'assets/images/marker-icon-2x-green.png',
          iconUrl: 'assets/images/marker-icon-green.png',
          shadowUrl: 'assets/images/marker-shadow.png'
        });
  }
// console.log(charger);
//   if(charger.chargerHealth.result.networkStatus==='Connected'){
//     HotelLef.Icon.Default.mergeOptions({
//     iconRetinaUrl: 'assets/images/marker-icon-2x-green.png',
//     iconUrl: 'assets/images/marker-icon-green.png',
//     shadowUrl: 'assets/images/marker-shadow.png'
//   });
// }
//  else if(charger.chargerHealth.result.networkStatus!=='Connected'){
//   HotelLef.Icon.Default.mergeOptions({
//       iconRetinaUrl: 'assets/images/marker-icon-2x-red.png',
//     iconUrl: 'assets/images/marker-icon-red.png',
//     shadowUrl: 'assets/images/marker-shadow.png'
//     });
// }
  return HotelLef.marker(data.position, { draggable: data.draggable })
    .on('click', (event) => this.markerClicked(event, index))
    .on('dragend', (event) => this.markerDragEnd(event, index));
}
markerClicked($event: any, index: number) {
  // console.log($event.latlng.lat, $event.latlng.lng);
 }

 markerDragEnd($event: any, index: number) {
   //console.log($event.target.getLatLng());
 } 
//  OnClickSelectRoom(item:any){
//  let url= "/app/hotelbooking?hotelDatail=0"
//      window.open(url);
//  }
 
 

 OnClickSelectRoom(item:any,ratePlan:any){
let ratePlans:any=[]
  // item.ratePlans.forEach((items:any)=>{
  //   console.log(items)
  //   if("rateCheckId" in items){
  //     if(items.rateCheckId){

  //   ratePlans.push({"roomCode":item?.code,"ratePlanCode":items.code,"rateCheckId":items.rateCheckId})
  //     }else{
  //       ratePlans.push({"roomCode":item?.code,"ratePlanCode":items.code,"rateCheckId":items.code})

  //     }
  // }else{
    
  //   ratePlans.push({"roomCode":item?.code,"ratePlanCode":items.code,"rateCheckId":items.code})

  // }})
  // console.log(ratePlans)
  //  let request:any=
  //   {
  //     "hotel": this.propData?.id,
  //     "roomCount":  this.searchDetail?.roomCount,
  //      "rooms":this.searchDetail.rooms,
      
  //    "checkIn": this.searchDetail?.checkInDate,
  //     "checkOut": this.searchDetail?.checkOutDate,
  //     "ratePlans": ratePlans
  // }
  // let hotelDetail:any={"name":this.propData?.name,"starRating":this.starRating,"location":this.propData?.location.name+","+this.propData?.location.state+","+this.propData?.location.countryName,"pinCode":this.propData?.pinCode
  // }

  // ,"img":this.propData?.media?.hotel[0]?.images[0]?.url,
  // JSON.parse(JSON.stringify(this.messageData))
  // let url= "/app/hotelbooking?roomDetail="+JSON.stringify(request)+"&searchDetail="+JSON.stringify(this.searchDetail)+"&hotelDetail="+JSON.stringify(hotelDetail)
  // window.open(url);
  // this.getPrice(item,ratePlan)
  this.getMMTPrice(item,ratePlan)

  }




  cancellationFilter(item:any){
    const parts = item.split('.');
    let cancellationPolicies = parts.filter((part:any) => part.trim() !== '');
    return cancellationPolicies
  }
  parseData() {
    
  }



  showSpiner:boolean=false
  tripResponse:any
getActiveTripList(){
  this.TripService
  .getActiveTrip( this.userUuid)
  .subscribe({
    next : (res:any) => {
      if(res) {
        const data = res
        this.tripResponse={
          tripName:data?.tripName,
          tripUid:data?.tripUid
        }
       
       } else {

       } 
    },error : (err) => {

      console.error("Error in fetching result");
    }
  })}
  getMMTPrice(requests:any,ratePlan:any){
    
    this.showSpiner=true
    let roomsData:any=[]
    let hotelDetail:any=JSON.parse(JSON.stringify(this.propData))
    for(let i=0;i<this.searchDetail.roomCount;i++){
      roomsData.push(JSON.parse(JSON.stringify(requests)))

    }
    // hotelDetail.mmtRooms=[JSON.parse(JSON.stringify(requests))]
    // console.log(hotelDetail)
    hotelDetail.mmtRooms=roomsData
    for(let i=0;i<this.searchDetail.roomCount;i++){
      hotelDetail.mmtRooms[i].ratePlans=[JSON.parse(JSON.stringify(ratePlan))]

    }
  //  console.log(this.searchDetail)
   

   let request:any={
    
      hotelRequest:this.searchDetail,
      selectedHotelOrder:{
      hotel:hotelDetail,
      mmtRequestId:this.requestIds?.mmtRequestId,
      agodaSearchId:this.requestIds?.agodaSearchId,
      expediaSessionId:this.requestIds?.expediaSessionId

      
    },
    requestUuid:this.requestIds?.mmtRequestId||this.requestIds?.agodaSearchId||this.requestIds?.expediaSessionId||''
   }
   if(this.tripEnable===true){
    request.tripUid=this.tripResponse?.tripUid
    }
    this.getPrice(request)
   }
   getExpediaPrice(requests:any,ratePlan:any){
    
    this.showSpiner=true
    let roomsData:any=[]
    let hotelDetail:any=JSON.parse(JSON.stringify(this.propData))
    for(let i=0;i<this.searchDetail.roomCount;i++){
      roomsData.push(JSON.parse(JSON.stringify(requests)))

    }
    
    hotelDetail.expediaRooms=roomsData
    for(let i=0;i<this.searchDetail.roomCount;i++){
      hotelDetail.expediaRooms[i].rates=[JSON.parse(JSON.stringify(ratePlan))]

    }
   

   let request:any={
    
      hotelRequest:this.searchDetail,
      selectedHotelOrder:{
      hotel:hotelDetail,
      mmtRequestId:this.requestIds?.mmtRequestId,
      agodaSearchId:this.requestIds?.agodaSearchId,
      expediaSessionId:this.requestIds?.expediaSessionId

      
    },
    requestUuid:this.requestIds?.mmtRequestId||this.requestIds?.agodaSearchId||this.requestIds?.expediaSessionId||''
   }
   if(this.tripEnable===true){
    request.tripUid=this.tripResponse?.tripUid
    }
    this.getPrice(request)
   }
    
  getPrice(request:any){
    
  //  
  //  console.log(this.searchDetail)
  
  this.DialogService.open({msg : "Price may be updated at checkout.",title : "Confirmation",buttonType : "Ok"})
       
  this.DialogService.onResponse((response :  string) => {
    if(response=="Ok") {
    this.HotelService.generateOrder(request)
    .subscribe({
      next : (res:any) => {
        this.showSpiner=false

        if(res) {
         let data:any
         data=res  
         if(data.orderNumber){

         let url= "/app/hotelbooking?id="+this.SettingsService.transform(data.orderNumber)
  window.open(url);
         }else{
          this.toastMsgService.setMsg({msg : "Unable to book; please try later !",msgTitle:  "Warning", msgType : "W"});

         }
        } else {    
          this.toastMsgService.setMsg({msg : "Unable to book; please try later !",msgTitle:  "Warning", msgType : "W"});

        } 
      },error : (err) => {
        this.showSpiner=false

        this.toastMsgService.setMsg({msg : "Unable to book; please try later !",msgTitle:  "Warning", msgType : "W"});

      }
    }
  )}})
  }


  parseCancellationPolicy (data: string) {
    const policy = [];

  const firstPeriod = data.match(/before (\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})/);
  const secondPeriod = data.match(/From (\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}) .*? till (\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})/);
  const thirdPeriod = data.match(/After (\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2})/);

  if (firstPeriod) {
    policy.push({
      cancelOnOrAfter: `N/A (Before ${firstPeriod[1].split(' ')[0]})`,
      cancelOnOrBefore: firstPeriod[1],
      charges: '₹0.00 (Free Cancellation)'
    });
  }

  if (secondPeriod) {
    policy.push({
      cancelOnOrAfter: secondPeriod[1],
      cancelOnOrBefore: secondPeriod[2],
      charges: '100% of booking amount'
    });
  }

  if (thirdPeriod) {
    policy.push({
      cancelOnOrAfter: thirdPeriod[1],
      cancelOnOrBefore: 'Check-In',
      charges: '100% of booking amount'
    });
  }

  return policy;
  
};



cancellationType(value:any,type:any){

  if(type==='PBA'){
    const percentageValue = this.convertToPercentage(value);
    return percentageValue
   }else if(type==='NR'){
    const rupeeValue = this.convertToRupees(value);

   return rupeeValue
   }else{
    return ''
   }
}
convertToPercentage(value: string): string {
  const numberValue = parseFloat(value);
  if(numberValue===0){
return '₹0.00 (Free Cancellation)'
  }else{
  return `${numberValue}% of booking amount`;}
}
convertToRupees(value: string): string {
  const numberValue = parseFloat(value);
  return `₹${numberValue.toFixed(2)} per room per Night`;
}
convertZone(input:any){
  const inputDateTime = input;
  const datePipe = new DatePipe('en-IN');

  let formattedDateTime:any = datePipe.transform(inputDateTime, 'yyyy-MM-ddTHH:mm:ss.SSSZ');
  return formattedDateTime;
}
dateFormate(date:any){
  const parsedDate = new Date(date);
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, 'd MMM yyyy EEEE');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
return date

}
dateFormateTime(date:any){
  const parsedDate = new Date(date);
  // console.log(parsedDate)
  const datePipe = new DatePipe('en-IN');
  date = datePipe.transform(parsedDate, 'dd-MM-yyyy hh:mm:ssa');
  // date = datePipe.transform(parsedDate, 'EEE dd MMM yyyy');
return date

}
onlyNumberKey(event:any) {
     
  let charCode = (event.which) ? event.which : event.keyCode;
  if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
  return true;
}
get childrenAges(): FormArray {
  return this.searchFg.get('childrenAges') as FormArray;
}

addChildAgeControl() {
  this.childrenAges.push(new FormControl(null));
}

removeChildAgeControl(index: number) {
  this.childrenAges.removeAt(index);
}
increment() {
  if (this.currentNumber < this.icurrentNumber * 4) {
    this.currentNumber++;
    this.adult=this.currentNumber+` `+"Adult"

  } }
  cIncrement() {
  if (this.ccurrentNumber  < this.icurrentNumber * 3) {
    this.childrenAges.push(new FormControl(0));

    this.ccurrentNumber++;
    
    this.child=this.ccurrentNumber+` `+"Child"
  }}
  iIncrement() {
  if (this.icurrentNumber < 5) {
    this.icurrentNumber++;
    if(this.icurrentNumber>1){
      this.room=this.icurrentNumber+` `+"Rooms"

    }else{
      this.room=this.icurrentNumber+` `+"Room"

    }
  } }

decrement() {
  if (this.currentNumber > 1) {
    this.currentNumber--;
    this.adult=this.currentNumber+` `+"Adult"

  }}
  cDecrement() {
  if (this.ccurrentNumber > 0) {
      this.childrenAges.removeAt(this.ccurrentNumber-1);

    this.ccurrentNumber--;
    this.child=this.ccurrentNumber+` `+"Child"

  }}
  iDecrement() {
  if (this.icurrentNumber > 0) {
    this.icurrentNumber--;
    if(this.icurrentNumber>1){
      this.room=this.icurrentNumber+` `+"Rooms"

    }else{
      this.room=this.icurrentNumber+` `+"Room"

    }
    const maxAdults = this.icurrentNumber * 4;

    if (this.currentNumber > maxAdults) {
      this.currentNumber = maxAdults; // Reduce to the max allowed adults for the new number of rooms
      this.adult=this.currentNumber+` `+"Adult"

    }

    // Adjust children if necessary
    const maxChildren = this.icurrentNumber * 3;
    if (this.ccurrentNumber > maxChildren) {
      const excessChildren = this.ccurrentNumber - maxChildren;

      this.ccurrentNumber = maxChildren; // Reduce to the max allowed children for the new number of rooms
      // this.childrenAges.removeAt(this.ccurrentNumber-1);
      for (let i = 0; i < excessChildren; i++) {
        this.childrenAges.removeAt(this.childrenAges.length - 1);
      }
      this.child=this.ccurrentNumber+` `+"Child"


    }
  }
}
selectedDetail:boolean=false
  SelectDetail(){
    this.selectedDetail=true

  }
  closeDetail(){
    this.selectedDetail=false

  }

  onOneWayDate(){
    if(this.searchFg?.value?.requestedDate){
      this.departureTime=this.dateFormate(this.searchFg?.value?.requestedDate)?.split(' ')
    }
    if(this.searchFg.value.requestedDate){
      let date:any=new Date();
      if (this.areDatesEqual(this.searchFg.value.requestedDate, date)) {
        // Your code for the condition when dates are the same
        this.searchFg.value.requestedDate=new Date()
      } else {
        // Your code for the condition when dates are not the same
      }
    }
      console.log(this.searchFg?.value?.childrenAges)
    this.searchFg=this.fb.group({
      "fromAirport" :  [this.searchFg?.value?.fromAirport,[Validators.required]],
      "toAirport" : [this.searchFg?.value?.toAirport,[Validators.required]],
      "requestedDate":[ this.searchFg?.value?.requestedDate],
      "requestedClass":[ this.searchFg?.value?.requestedClass],
      "paxCount":[this.searchFg?.value?.paxCount],
      "adultCount":[this.searchFg?.value?.adultCount],
      "childCount":[this.searchFg?.value?.childCount],
      "infantCount":[this.searchFg?.value?.infantCount],
      "returnDate":[this.searchFg?.value?.returnDate],
      "menu":[this.searchFg?.value?.menu],
      "childrenAges":this.fb.array(this.searchFg?.value?.childrenAges)

    });

    
  }

  onRChangeDate(){
   
      if(this.searchFg?.value?.requestedDate){
        this.arrivelTime=this.dateFormate(this.searchFg?.value?.returnDate)?.split(' ')
      }

    if(this.searchFg?.value?.returnDate){
      let date:any=new Date();
      if (this.areDatesEqual(this.searchFg.value.returnDate, date)) {
        // Your code for the condition when dates are the same
        this.searchFg.value.returnDate=new Date()
      } else {
        // Your code for the condition when dates are not the same
      }
  
    
     }
    this.searchFg=this.fb.group({
      "fromAirport" :  [this.searchFg?.value?.fromAirport,[Validators.required]],
      "toAirport" : [this.searchFg?.value?.toAirport,[Validators.required]],
      "requestedDate":[ this.searchFg?.value?.requestedDate],
      "requestedClass":[ this.searchFg?.value?.requestedClass],
      "paxCount":[this.searchFg?.value?.paxCount],
      "adultCount":[this.searchFg?.value?.adultCount],
      "childCount":[this.searchFg?.value?.childCount],
      "infantCount":[this.searchFg?.value?.infantCount],
      "returnDate":[this.searchFg?.value?.returnDate],
      "menu":["return"],
      "childrenAges":this.fb.array(this.searchFg?.value?.childrenAges)

    });
    if(this.searchFg?.value?.returnDate){
      this.arrivelTime=this.dateFormate(this.searchFg?.value?.returnDate)?.split(' ')
    }
  }



  searchHotel(){
 this.selectedDetail=false

    this.pointer='Highlights'
    console.log()

    let request:any={
    "searchDetail":{
      
        "city": this.departure,
        "checkInDate": this.convertTimeZone(this.searchFg.value.requestedDate),
        "checkOutDate": this.convertTimeZone(this.searchFg.value.returnDate),
        "roomCount": this.roomCount,
        // "adultCount": this.currentNumber,
        // "childCount": this.ccurrentNumber,
        "rooms":this.roomss,
        'country':this.searchDetail.country,
        // "childrenAges":this.searchFg?.value?.childrenAges
        "requestId":this.searchDetail?.requestId,
        "rateType":this.searchDetail?.rateType
    },
    "id":this.messageRequestid
    }
    // this.searchDetail.adultCount=request?.adultCount
    this.searchDetail.checkInDate=request?.searchDetail?.checkInDate
    this.searchDetail.checkOutDate=request?.searchDetail?.checkOutDate
    this.searchDetail.roomCount=request?.searchDetail?.roomCount
    this.searchDetail.rooms=request?.searchDetail?.rooms
console.log(this.searchDetail)
    // this.searchDetail.childCount=request?.childCount
    this.hotelDetailByDetail(request?.searchDetail,request.id)

  }
  areDatesEqual(date1: Date, date2: Date): boolean {
    // Compare year, month, and day to check if the dates are equal
    return date1.getFullYear() === date2.getFullYear() &&
           date1.getMonth() === date2.getMonth() &&
           date1.getDate() === date2.getDate();
  }
  minData=new Date()
  date1Plus(item:any)
  {
    const originalDate = new Date(item);
    const newDate = new Date(originalDate.setDate(originalDate.getDate() + 1));
    return newDate
  } 
  convertTimeZone(input:any){
    const inputDateTime = input;
    const datePipe = new DatePipe('en-IN');
  
    let formattedDateTime:any = datePipe.transform(inputDateTime, 'yyyy-MM-dd');
    return formattedDateTime;
  }


  roomCount: number = 1;
roomss: any[] = [];
roomOptions: number[] = [1, 2, 3, 4, 5]; // You can change the number of room options
adultOptions: number[] = [1, 2, 3, 4];
childOptions: number[] = [0,1, 2, 3];
childAgeOptions: number[] = [1, 2, 3,4,5,6,7,8,9,10,11];

onRoomCountChange() {
  this.roomss = [];
  for (let i = 0; i < this.roomCount; i++) {

    this.roomss.push({
      adults: 1,
      childrenCount: 0,
      childrenAges: []
    });
  }
  console.log(this.roomss)
  if(this.roomCount>1){
    this.room=this.roomCount+` `+"Rooms"
  
  }else{
    this.room=this.roomCount+` `+"Room"
  
  }  
  this.adult=this.calculateTotals(this.roomss).totalAdults+` `+"Adult"
  
  this.child=this.calculateTotals(this.roomss).totalChildren+` `+"Child"
}

onAdultChange(){
  this.adult=this.calculateTotals(this.roomss).totalAdults+` `+"Adult"

}
onChildrenCountChange(roomIndex: number) {
  const room = this.roomss[roomIndex];
  // console.log(room.childrenCount)
  room.childrenAges = Array.from({ length: room.childrenCount }, () => 1);
  // console.log(room.childrenAges)
  if(this.roomCount>1){
    this.room=this.roomCount+` `+"Rooms"
  
  }else{
    this.room=this.roomCount+` `+"Room"
  
  }  
  this.adult=this.calculateTotals(this.roomss).totalAdults+` `+"Adult"
  this.child=this.calculateTotals(this.roomss).totalChildren+` `+"Child"
}

calculateTotals(data: any) {
  let totalAdults = 0;
  let totalChildren = 0;

  data.forEach((item:any) => {
      // Add to total adults
      totalAdults += typeof item.adults === 'string' ? parseInt(item.adults, 10) : item.adults;

      // Add to total children based on the childrenCount
      totalChildren += typeof item.childrenCount === 'string' ? parseInt(item.childrenCount, 10) : item.childrenCount;
  });

  return { totalAdults, totalChildren };
}



tripEnable:boolean=false
ENABLE_TRIP_MGMT(){

    this.UserService.ENABLE_TRIP_MGMT()
    .subscribe({
      next : (res:any) => {
        if(res) {
       if(res.policyType==='TRIP_MGMT'){
        if(res.rule==='1'){
          this.tripEnable=true
        }else 
        if(res.rule==='2'){
          this.tripEnable=true
                    }else{
          this.tripEnable=false

        }

       }
 
      }else{

      }},error : (err) => {
  
        console.error("Error in fetching data");
      }
    }
  )
  
}


convertToSameFormate(item:any){
//  +++++++++++++++Media++++++++++++++++++
//  ++++++++++++++++Media+++++++++++++++++
//  ++++++++++++++++Media+++++++++++++++++
//  ++++++++++++++++Media+++++++++++++++++
//  +++++++++++++++++Media++++++++++++++++

  if(item.mmtMedia){

  }else if(item.agodaMedia){
   
  }else if(item.expediaImages){
    function processImages(images:any) {
      const sortedImages = images
          .sort((a:any, b:any) => b.hero_image - a.hero_image) // Sort by hero_image (true comes first)
          .flatMap((image:any) => image.links.map((link:any) => link.href)); // Extract href values from links
  
      return sortedImages;
  }
    item.mmtMedia=processImages(item.expediaImages)

  }

  // console.log( item.mmtMedia)
//  +++++++++++++++amenities++++++++++++++++++
//  ++++++++++++++++amenities+++++++++++++++++
//  ++++++++++++++++amenities+++++++++++++++++
//  ++++++++++++++++amenities+++++++++++++++++
//  +++++++++++++++++amenities++++++++++++++++
if(item.mmtAmenities){

}else if(item.agodaAmenities){
 
}else if(item.expediaAmenities){
  item.mmtAmenities=item.expediaAmenities
}

//  +++++++++++++++Media++++++++++++++++++
//  ++++++++++++++++Media+++++++++++++++++
//  ++++++++++++++++Media+++++++++++++++++
//  ++++++++++++++++Media+++++++++++++++++
//  +++++++++++++++++Media++++++++++++++++

if(item.mmtPolicies){

}else if(item.expediaPolicies){
if(item?.expediaPolicies?.know_before_you_go){
  const parser = new DOMParser();
const doc = parser.parseFromString(item?.expediaPolicies?.know_before_you_go, "text/html");

// Extract the <li> elements
const listItems = Array.from(doc.querySelectorAll("li"));

// Map the text content of each <li> to an array
const arrayData = listItems.map((list:any) => list.textContent.trim());

  item.mmtPolicies=arrayData.map((data:any)=>{
    return {category:'',policyList:[data]}
  })
  
}
 

}


  return item
}

mmtBaseFare(base:any,couponDiscount:any,hotelDiscount:any){
  let data:any=(base?(base):0)-(couponDiscount?(couponDiscount):0)-(hotelDiscount?(hotelDiscount):0)
return data
}
}

